import { createFileRoute } from "@tanstack/react-router";
import { CookiePolicyPage, type CookieEntry } from "@evomatic-ui-kit/cookies";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/cookies-policy")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  const cookies: CookieEntry[] = [
    {
      name: "cookieConsent",
      purpose: t("cookie_policy.cookie_consent_purpose"),
      duration: t("cookie_policy.persistent"),
      persistent: true,
    },
    {
      name: "auth-data",
      purpose: t("cookie_policy.cookie_auth_data_purpose"),
      duration: t("cookie_policy.until_logout"),
      persistent: true,
    },
    {
      name: "expandedSideBar",
      purpose: t("cookie_policy.cookie_sidebar_purpose"),
      duration: t("cookie_policy.persistent"),
      persistent: true,
    },
    {
      name: "currentLang",
      purpose: t("cookie_policy.cookie_current_lang_purpose"),
      duration: t("cookie_policy.persistent"),
      persistent: true,
    }
  ];

  return (
    <div className="size-full overflow-y-auto">
      <CookiePolicyPage
        dpoContact="info@evomatic.it"
        supportEmail="info@evomatic.it"
        lastUpdate={format(new Date(2026, 6, 9), "d MMMM yyyy")}
        cookies={cookies}
      />
    </div>
  );
}
